import { useContext } from "react";
import OwLabel from "../../shared/OwLabel/OwLabel";
import IOrder_ItemUI from "../../../models/IOrder_ItemUI";
import UserService from "../../../services/UserService";
import UserContext from "../../../contexts/UserContext";
import SupplierContext from "../../../contexts/SupplierContext";
import UserTypesEnum from "../../../models/UserTypesEnum";
import "./LineItemQtyFulfillmentDetail.scss";

type Props = {
    row: IOrder_ItemUI;
};

const ALLOWED_USER_TYPES = [
    UserTypesEnum.ADMIN,
    UserTypesEnum.MANAGEMENT,
    UserTypesEnum.INVENTORY_MGMT,
    UserTypesEnum.ORDER_MGMT,
    UserTypesEnum.SHIP_MGMT,
];

export const LineItemQtyFulfillmentDetail = (props: Props) => {
    const supplierModel = useContext(SupplierContext);
    const userModel = useContext(UserContext);

    const showInventoryDetails = UserService.showInventoryDetails(supplierModel, userModel);

    if (!showInventoryDetails || !userModel.isSupplierUser) {
        return null;
    }

    const userTypeId = userModel.supplierUserToken?.user_type_id;
    if (!userTypeId || !ALLOWED_USER_TYPES.includes(userTypeId)) {
        return null;
    }

    if (!props.row.Catalog_Item?.has_inventory) {
        return null;
    }

    const qty = Number(props.row.qty) || 0;
    const qtyReserved = Number(props.row.qty_reserved) || 0;
    const qtyPending = Number(props.row.qty_pending) || 0;

    if (qty === 0 && qtyReserved === 0 && qtyPending === 0) {
        return null;
    }

    const fillPercentage = qty > 0 ? Math.min(100, (qtyReserved / qty) * 100) : 0;

    let fillColorClass = "fill-bar-red";
    if (fillPercentage >= 80) {
        fillColorClass = "fill-bar-green";
    } else if (fillPercentage >= 50) {
        fillColorClass = "fill-bar-yellow";
    }

    return (
        <div className="LineItemQtyFulfillmentDetail mt-1">
            <div className="d-flex justify-content-end text-small">
                <OwLabel title={"reserved"} postText={":"} className="me-1" />
                {qtyReserved}/{qty}
            </div>
            {qtyPending > 0 ? (
                <div className="d-flex justify-content-end text-small text-muted">
                    <OwLabel title={"qty_pending"} postText={":"} className="me-1" />
                    {qtyPending}
                </div>
            ) : null}
            <div className="fill-bar-track">
                <div className={`fill-bar-fill ${fillColorClass}`} style={{ width: `${fillPercentage}%` }} />
            </div>
        </div>
    );
};
